import {Action} from '@ngrx/store';

export const GET_POPUP = '[Profile] Get Popup';
export const GET_POPUP_SUCCESS = '[Profile] Get Popup Success';
export const GET_POPUP_ERROR = '[Profile] Get Popup Error';

export const UPDATE_PROFILE_DETAILS = '[Profile] Update Profile Details';
export const UPDATE_PROFILE_DETAILS_SUCCESS = '[Profile] Update Profile Details Success';
export const UPDATE_PROFILE_DETAILS_ERROR = '[Profile] Update Profile Details Error';


export class GetPopup implements Action {
  readonly type = GET_POPUP;

  constructor(public payload: any) {
  }
}

export class GetPopupSuccess implements Action {
  readonly type = GET_POPUP_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetPopupError implements Action {
  readonly type = GET_POPUP_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateProfileDetails implements Action {
    readonly type = UPDATE_PROFILE_DETAILS;
  
    constructor(public payload: any) {
    }
  }
  
  export class UpdateProfileDetailsSuccess implements Action {
    readonly type = UPDATE_PROFILE_DETAILS_SUCCESS;
  
    constructor(public payload: any) {
    }
  }
  
  export class UpdateProfileDetailsError implements Action {
    readonly type = UPDATE_PROFILE_DETAILS_ERROR;
  
    constructor(public payload: any) {
    }
  }

export type ProfileAction = GetPopup
| GetPopupSuccess
| GetPopupError
| UpdateProfileDetails
| UpdateProfileDetailsSuccess
| UpdateProfileDetailsError


// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/store/actions/profile.action.ts